import * as React from 'react';
import { ActionButton, Checkbox, ComboBox, DatePicker, DayOfWeek, DefaultButton, defaultDatePickerStrings, Dropdown, ICalendarMonthProps, ICalendarStrings, IComboBoxOption, IComboBoxProps, IDatePickerStrings, IDropdownOption, ISpinButtonStyles, MessageBar, MessageBarType, Pivot, PivotItem, Position, PrimaryButton, SpinButton, Stack, TextField, Toggle } from '@fluentui/react';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';
import { IEvent } from '../../../../../Models/Event/IEvent';
import { IAgeGoup } from '../../../../../Models/AgeGroups/IAgeGroup';
import { IRoom } from '../../../../../Models/Rooms/IRoom';
import { isNumeric } from '../../../../../Tools/Validation';
import { AttendeeRegistrationList } from '../AttendeeRegistrationList/AttendeeRegistrationList';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';
import { EventPropertiesImageView } from './EventPropertiesImageView';
import { TeachersList } from '../../Teachers/TeachersList/TeachersList';
import EventSchedulesList  from '../../EventSchedules/EventSchedulesList/EventSchedulesList';


interface IEventPropertiesViewProps {
    item: IEvent;
    saveEvent: () => void;
    close: () => void;
    isValid: boolean;
    isLoading: boolean;
    propertyChanged: (key: string, value: any) => void;
    valid: (value: boolean) => void;
    ageGroups: IAgeGoup[];
    eventTypes: IEventType[];
    rooms: IRoom[];

    setIcon: (file: File) => void;
    setIconUrl: (url: any) => void;
    IconUrl: any;

    profile: IUserProfile;
    loadImage: () => void;
}

const styles: Partial<ISpinButtonStyles> = { root: { width: 130 }, spinButtonWrapper: { width: 130 } };

const days: IDropdownOption[] = [
    { text: 'Dle dohody', key: -1 },
    { text: 'Pondělí', key: DayOfWeek.Monday },
    { text: 'Úterý', key: DayOfWeek.Tuesday },
    { text: 'Středa', key: DayOfWeek.Wednesday },
    { text: 'Čtvrtek', key: DayOfWeek.Thursday },
    { text: 'Pátek', key: DayOfWeek.Friday },
    { text: 'Sobota', key: DayOfWeek.Saturday },
    { text: 'Neděle', key: DayOfWeek.Sunday },
];

//const st : Partial<ICalendarStrings> = {
//     months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"] 
//}

//const CalendarMonthProps:Partial<ICalendarMonthProps> = {
//    strings: st
//}
const CzDatePickerStrings: IDatePickerStrings = {
    ...defaultDatePickerStrings,
    months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
    days: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
    shortMonths: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"],
    shortDays: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
    goToToday: "Dnes",
    
}


export const EventPropertiesView: React.FunctionComponent<IEventPropertiesViewProps> = (props) => {


    const [eventTypeOptions, setEventTypeOptions] = React.useState<IComboBoxOption[]>([])
    const [ageGroupOptions, setAgeGroupOptions] = React.useState<IComboBoxOption[]>([])
    const [roomOptions, setRoomOptions] = React.useState<IComboBoxOption[]>([])
    
    const [registrationTimeKey, setRegistrationTimeKey] = React.useState<number>(0);
    
    const dateTimeOptions: IComboBoxOption[] = [];
    
    let dateTimeOptionsInterval = 15;

    {
        let id = 0;
        for (let i = 0; i < 24; i++) {
            for (let j = 0; j < 60; j += dateTimeOptionsInterval) {
                const time = (i < 10 ? '0' + i : i) + ':' + (j < 10 ? '0' + j : j);
                dateTimeOptions.push(
                    { 
                        key: id, 
                        text: time
                    });
                id++;
            }
        }
    }
    
    const onFormatDate = (date?: Date): string => {
        return !date ? '' : date.getDate() + '.' + (date.getMonth() + 1) + '.' + (date.getFullYear());
    };

    React.useEffect(() => {
        const options = props.ageGroups.map(x => {
            const o: IComboBoxOption = {
                key: x.id,
                text: x.name
            }
            return o;
        });
        setAgeGroupOptions(options)
    }, [props.ageGroups])

    React.useEffect(() => {
        const options = props.eventTypes.map(x => {
            const o: IComboBoxOption = {
                key: x.id,
                text: x.name
            }
            return o;
        });
        setEventTypeOptions(options)
    }, [props.eventTypes]);

    React.useEffect(() => {
        const options = props.rooms.map(x => {
            const o: IComboBoxOption = {
                key: x.id,
                text: x.name
            }
            return o;
        });
        setRoomOptions(options)
    }, [props.rooms]);
    
    React.useEffect(() => {
        if (props.item.registrationTime) {
            const time = props.item.registrationTime as Date;
            const hours = time.getHours();
            const minutes = time.getMinutes();
            const key = hours * 60 / dateTimeOptionsInterval + minutes / dateTimeOptionsInterval;
            setRegistrationTimeKey(key);
        }
        
    }, [props.item.registrationTime]);

    const propertyChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (event) {
            var id = (event.target as HTMLInputElement).id;
            props.propertyChanged(id, newValue);
        }
    }

    const onSchoolYear = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("schoolYear", newValue);
            }
        }
    }

    const onNumberOfLessons = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("numberOfLessons", newValue);
            }
        }
    }
    const onLessonLength = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("lessonLength", newValue);
            }
        }
    }


    const onSeetsChanged = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("seets", newValue);
            }
        }
    }
    const onSubstitutesChanged = (event: React.SyntheticEvent<HTMLElement>, newValue?: string) => {
        if (newValue !== undefined) {
            if (event) {
                props.propertyChanged("substitutes", newValue);
            }
        }
    }


    const onTimeChanged: IComboBoxProps['onChange'] = (event, option) => {
        let time =  option!.text.split(':');
        let hours = parseInt(time[0]);
        let minutes = parseInt(time[1]);

        let date = new Date(props.item.registrationStart);
        date.setHours(hours);
        date.setMinutes(minutes);
        date.setSeconds(0);
        props.propertyChanged("registrationTime", date);
        
        setRegistrationTimeKey(option!.key as number);
    }
    
    const onAgeGroupsChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("ageGroupId", option!.key as number);
    }
    const onEventTypeChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("eventTypeId", option!.key as number);
    }

    const onRoomChanged: IComboBoxProps['onChange'] = (event, option) => {
        props.propertyChanged("roomId", option!.key as number);
    }
    const onDayOfWeek = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        props.propertyChanged("dayOfWeek", option!.key as number);
    }

    const onPriceType = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
        props.propertyChanged("priceType", option!.key as number);
    }

    const validate = (item: IEvent) => {
        const valid: boolean = item.name != "" &&
            item.ageGroupId !== 0 &&
            item.eventTypeId !== 0 &&
            item.roomId !== 0 &&
            isNumeric(item.schoolYear) &&
            item.schoolYear >= 2022           
        props.valid(valid);
    }

    React.useEffect(() => {
        validate(props.item);
    }, [props.item])

    const fileButtonClick = () => {
        if (document) {
            document.getElementById('hiddenFileInput')?.click();
        }
    }

    const onChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event && event.target && event.target.files) {
            const files = event.target.files;
            const newaFiles: File[] = []
            if (event.target.files.length > 0) {
                props.setIconUrl(window.URL.createObjectURL(event.target.files[0]));
                props.setIcon(event.target.files[0]);
            }
        }
    }

    return (<Pivot aria-label="Akce">
        <PivotItem
            headerText="Obecné"
            headerButtonProps={{
                'data-order': 1,
                'data-title': 'Obecné',
            }}>
            <Stack tokens={{ childrenGap: 15 }} styles={{ root: { paddingTop: 40 } }}>

                <SpinButton
                    id="schoolYear"
                    key="schoolYear"
                    labelPosition={Position.top}
                    label="Školní rok"
                    value={props.item.schoolYear.toString()}
                    min={2022}
                    max={3000}
                    step={1}
                    onChange={onSchoolYear}
                    incrementButtonAriaLabel="Zvýší hodnotu o 1"
                    decrementButtonAriaLabel="Sníží hodnotu o 1"
                    styles={styles} />

                <Toggle checked={props.item.showOnWeb} label="Zobrazovat na webu" defaultChecked onText="Ano" offText="Ne" onChange={(e, checked) => { props.propertyChanged("showOnWeb", checked ? checked : false); }} />

                <TextField required id="name" key="name" label="Název" disabled={props.isLoading} value={props.item.name}
                    onChange={propertyChanged} />

                <TextField id="description" key="description" multiline label="Popis" disabled={props.isLoading} value={props.item.description}
                    onChange={propertyChanged} />
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <Stack grow>

                        <Dropdown onChange={onPriceType} selectedKey={props.item.priceType} styles={{ root: { minWidth: 185 } }} label="Cena za" options={[{ key: 0, text: "Akci" }, { key: 1, text: "Pololetí" }]} />
                    </Stack>
                    {props.item.priceType === 0 ?
                        <Stack horizontal grow>
                            <TextField id="price" key="price" label="Cena celkem" disabled={props.isLoading} value={props.item.price.toString()}
                                onChange={propertyChanged} />
                        </Stack> : null}

                    {props.item.priceType === 1 ?
                        <Stack horizontal grow tokens={{ childrenGap: 10 }}>
                            <TextField id="firstSemesterPrice" key="firstSemesterPrice" label="1 pololetí" disabled={props.isLoading} value={props.item.firstSemesterPrice.toString()}
                                onChange={propertyChanged} />
                            <TextField id="secondSemesterPrice" key="secondSemesterPrice" label="2 pololetí" disabled={props.isLoading} value={props.item.secondSemesterPrice.toString()}
                                onChange={propertyChanged} />
                        </Stack> : null}
                </Stack>


                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <SpinButton
                        id="lessonLength"
                        key="lessonLength"
                        labelPosition={Position.top}
                        label="Délka lekce"
                        value={props.item.lessonLength.toString()}
                        min={0}
                        max={3000}
                        step={1}
                        onChange={onLessonLength}
                        incrementButtonAriaLabel="Zvýší hodnotu o 1"
                        decrementButtonAriaLabel="Sníží hodnotu o 1"
                        styles={styles}
                        disabled={props.isLoading} />
                    <SpinButton
                        id="numberOfLessons"
                        key="numberOfLessons"
                        labelPosition={Position.top}
                        label="Počet lekcí"
                        value={props.item.numberOfLessons.toString()}
                        min={0}
                        max={3000}
                        step={1}
                        onChange={onNumberOfLessons}
                        incrementButtonAriaLabel="Zvýší hodnotu o 1"
                        decrementButtonAriaLabel="Sníží hodnotu o 1"
                        styles={styles}
                        disabled={props.isLoading} />

                </Stack>
                <Stack horizontal tokens={{ childrenGap: 10 }}>
                    <SpinButton
                        id="seets"
                        key="seets"
                        labelPosition={Position.top}
                        label="Volných míst"
                        value={props.item.seets.toString()}
                        min={0}
                        max={3000}
                        step={1}
                        onChange={onSeetsChanged}
                        incrementButtonAriaLabel="Zvýší hodnotu o 1"
                        decrementButtonAriaLabel="Sníží hodnotu o 1"
                        styles={styles}
                        disabled={props.isLoading} />
                    <SpinButton
                        id="substitutes"
                        key="substitutes"
                        labelPosition={Position.top}
                        label="Počet náhradníků"
                        value={props.item.substitutes.toString()}
                        min={0}
                        max={3000}
                        step={1}
                        onChange={onSubstitutesChanged}
                        incrementButtonAriaLabel="Zvýší hodnotu o 1"
                        decrementButtonAriaLabel="Sníží hodnotu o 1"
                        styles={styles}
                        disabled={props.isLoading} />

                </Stack>
                <Stack horizontal verticalAlign="end" tokens={{ childrenGap: 10 }} >
                    <Stack grow styles={{ root: { paddingBottom: 5 } }}>
                        <Dropdown
                            disabled={props.isLoading}
                            selectedKey={props.item.dayOfWeek}
                            label="Den v týdnu"
                            options={days}
                            onChange={onDayOfWeek} />
                    </Stack>
                    <Stack grow styles={{ root: { paddingTop: 10, marginTop: 10 } }}>
                        <DatePicker
                            label="Datum první hodiny"
                            disabled={props.isLoading}
                            value={props.item.dateOfFirstLesson as Date}
                            onSelectDate={(date: Date | null | undefined) => { props.propertyChanged("dateOfFirstLesson", date); }}
                            firstDayOfWeek={DayOfWeek.Monday}
                            showWeekNumbers={true}
                            firstWeekOfYear={1}
                            showMonthPickerAsOverlay={true}
                            placeholder="Vyberte datum první lekce"
                            ariaLabel="Vyberte datum první lekce"
                            // DatePicker uses English strings by default. For localized apps, you must override this prop.
                            strings={CzDatePickerStrings}
                            formatDate={onFormatDate}
                        />
                    </Stack>
                </Stack>
                <TextField id="time" key="time" label="Čas konání" disabled={props.isLoading} value={props.item.time}
                    onChange={propertyChanged} />

                <DatePicker
                    label="Přihlášky od"
                    disabled={props.isLoading}
                    value={props.item.registrationStart as Date}
                    onSelectDate={(date: Date | null | undefined) => { props.propertyChanged("registrationStart", date); }}
                    firstDayOfWeek={DayOfWeek.Monday}
                    showWeekNumbers={true}
                    firstWeekOfYear={1}
                    showMonthPickerAsOverlay={true}
                    placeholder="Vyberte datum od kdy se dá přihlásit"
                    ariaLabel="Vyberte datum od kdy se dá přihlásit"
                    strings={CzDatePickerStrings}
                    formatDate={onFormatDate}
                />
                <ComboBox
                    label="Čas přihlašování"
                    disabled={props.isLoading}
                    selectedKey={registrationTimeKey}
                    options={dateTimeOptions}
                    comboBoxOptionStyles={{ root: { width: 80 } }}
                    onChange={onTimeChanged}
                />
                <ComboBox
                    selectedKey={props.item.eventTypeId}
                    disabled={props.isLoading}
                    label="Typ události"
                    options={eventTypeOptions}
                    onChange={onEventTypeChanged}
                />
                <ComboBox
                    disabled={props.isLoading}
                    selectedKey={props.item.ageGroupId}
                    label="Věková skupina"
                    options={ageGroupOptions}
                    onChange={onAgeGroupsChanged}
                />
                <ComboBox
                    disabled={props.isLoading}
                    selectedKey={props.item.roomId}
                    label="Místo konání"
                    options={roomOptions}
                    onChange={onRoomChanged}
                />
            </Stack>
            <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                <PrimaryButton disabled={!props.isValid} onClick={props.saveEvent}>Uložit</PrimaryButton>
                <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
            </Stack>
        </PivotItem>
        {props.item.id > 0 ?
            <PivotItem
                headerText="Obrázky">
                <EventPropertiesImageView
                    eventId={props.item.id}
                    fileButtonClick={fileButtonClick}
                    IconUrl={props.IconUrl}
                    imageChaged={onChange}
                    loadImage={props.loadImage}
                />

                <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">
                    <PrimaryButton disabled={!props.isValid} onClick={props.saveEvent}>Uložit</PrimaryButton>
                    <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                </Stack>
            </PivotItem>
            : null}
        {props.item.id > 0 ?
        <PivotItem
            headerText="Přihlášení žáci"
            headerButtonProps={{
                'data-order': 1,
                'data-title': 'Přihlášení žáci',
            }}>
            <AttendeeRegistrationList profile={props.profile} showTitle={false} eventName={props.item.name} eventId={props.item.id} />
        </PivotItem> : null}
        {props.item.id > 0 ?
            <PivotItem
                headerText="Lektoři"
                headerButtonProps={{
                    'data-order': 1,
                    'data-title': 'Lektoři',
                }}>
                <TeachersList eventId={props.item.id} />
            </PivotItem> : null}

        {props.item.id > 0 ?
            <PivotItem
            headerText="Lekce / docházka"
        headerButtonProps={{
            'data-order': 1,
            'data-title': 'Lekce',
        }}>
        <EventSchedulesList lessonLength={props.item.lessonLength} numberOfLessons={props.item.numberOfLessons} eventId={props.item.id} />
            </PivotItem>
            : null}




  </Pivot>)
}